const SOURCE_META: Record<string, { label: string; className: string }> = {
  GLPI:     { label: 'GLPI Agent', className: 'bg-indigo-50 text-indigo-700 border-indigo-200' },
  WINAUDIT: { label: 'WinAudit',   className: 'bg-purple-50 text-purple-700 border-purple-200' },
  CSV:      { label: 'CSV',        className: 'bg-gray-100 text-gray-600 border-gray-200' },
}

// Shows where an Asset's data came from (GLPI Agent sync, WinAudit file import,
// CSV bulk import) — unset means it was entered by hand.
export default function DataSourceBadge({ source }: { source?: string | null }) {
  if (!source || !SOURCE_META[source]) return null
  const { label, className } = SOURCE_META[source]
  return (
    <span className={`text-[10px] px-1.5 py-0.5 rounded border font-medium whitespace-nowrap ${className}`}>{label}</span>
  )
}
